import { useEffect, useState } from 'react';

type ScriptStatus = 'idle' | 'loading' | 'ready' | 'error';

export const useScript = (src: string, id?: string) => {
  const [status, setStatus] = useState<ScriptStatus>('idle');

  useEffect(() => {
    if (!src) {
      setStatus('error');
      return;
    }

    // Check if script already exists
    let script = document.querySelector(`script[src="${src}"]`) as HTMLScriptElement;

    if (!script) {
      script = document.createElement('script');
      script.src = src;
      script.async = true;
      if (id) script.id = id;

      setStatus('loading');

      script.onload = () => {
        setStatus('ready');
      };

      script.onerror = () => {
        script.remove();
        setStatus('error');
      };

      document.body.appendChild(script);
    } else {
      setStatus('ready');
    }

    return () => {
      if (script && id) {
        script.remove();
        setStatus('idle');
      }
    };
  }, [src, id]);

  return status;
};
